import { render } from "./HeroiconsSolidArrowNarrowUp.vue?vue&type=template&id=872245d8"
const script = {}

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowNarrowUp.vue"]])

export default __exports__